module.exports = __webpack_public_path__ + "media/images/pharmacies/pc-aa43fb0a22bf8ffe5a404c6a5d74e892.png";